export const SETAPPROVALLIST = "SETAPPROVALLIST";
export const SETUSERLIST = "SETUSERLIST";
export const SETAPPROVALPROCESSLIST = "SETAPPROVALPROCESSLIST";
export const SETAPPROVALSTEP = "SETAPPROVALSTEP";
export const SETAPPROVERTYPELIST = "SETAPPROVERTYPELIST";
export const SETAPPROVERLIST = "SETAPPROVERLIST";
export const SETFIELDLIST = "SETFIELDLIST";
export const SETCONDITIONLIST = "SETCONDITIONLIST";
export const CLEARCONDITIONLIST = "CLEARCONDITIONLIST";
export const SETATTACHMENTS = "SETATTACHMENTS";
export const SETFAILEDAPPROVALLIST = "SETFAILEDAPPROVALLIST";
export const SETAPPROVALBASICFILTERDATA = "SETAPPROVALBASICFILTERDATA";
export const SETFAILEDAPPROVALBASICFILTERDATA = "SETFAILEDAPPROVALBASICFILTERDATA";


